export const getUser = (state) => state.user?.users?.users;
export const getAllUser = (state) => state.user?.users;
export const getTotalUsers = (state) => state.user.total;
export const getuserdetailSelector = (state) => state.user?.editedRestaurant;

export const getAttendanceDataSelector = (state) => state.user?.attendancedata;